import React from 'react';

import { FormattedMessage } from 'react-intl';

import { renderFormBasedOnType } from '../../../../../services/filtering/filter-form-render-service';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import messages from './messages';

export default {
  id: 'postalCode',
  displayName: <FormattedMessage {...messages.postalCode} />,
  type: OptionFormTypes.TYPE_STRING,
  filterValue: 'PostalCode',
  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_STRING, criteriaInformations);
  },
};
